export function initSingle() {

  console.log('Init Single');


  //Collpase Menu
  $('.collapse--menu .collapse--btn').on('click', function(e) {

    e.preventDefault();
    if ($(e.currentTarget).hasClass('disabled')) return;

    $('.collapse--menu').find('.active').removeClass('active');
    $(e.currentTarget).addClass('active');

    var $target = $($(e.currentTarget).attr('href'));
    $('.collapse--container .active').removeClass('active');
    $target.addClass('active');

    TweenMax.to(".collapse--container", 0.8, {
      height: $target.outerHeight(),
      overwrite: true,
      ease: Power3.easeOut,
      onComplete: function() {
        $(".collapse--container").css({ height: "auto" });
      }
    }, 0);

  })

  $($('.collapse--menu .collapse--btn')[0]).trigger('click');


  window.fbAsyncInit = function() {

    console.log("fbAsyncInit");

    FB.init({
      appId: '415578685512178',
      xfbml: true,
      version: 'v2.5'
    });

    var videoPlayer;
    FB.Event.subscribe('xfbml.ready', function(msg) {
      console.log("fb event");
      if (msg.type === 'video') {
        videoPlayer = msg.instance;
      }
      $('.video--details').addClass('show');

      $('#transcription .time a').on('click', function(e) {
        e.preventDefault();
        videoPlayer.seek($(e.currentTarget).data("time"));
      })
    });


  }


  $('.fb-share, .in_share').click(function(e) {
    e.preventDefault();
    window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    return false;
  });

}
